import dayjs from 'dayjs'

export const getTireSizeCount = (tireSizes = []) =>
  tireSizes.reduce((acc, next) =>
    acc + next.sizes.length, 0)

export const getAggregateOfferData = (productPrice = '') => {
  const [lowPrice, highPrice] = productPrice.split('-')
  return { lowPrice, highPrice }
}

export const generateReviewsListForSchema = (reviews) => reviews.map(({
  UserNickname = '',
  ReviewText = '',
  SubmissionTime = ''
}) => ({
  '@type': 'Review',
  name: UserNickname,
  reviewBody: ReviewText,
  datePublished: SubmissionTime && dayjs(SubmissionTime).format('YYYY-MM-DD'),
  author: { '@type': 'Person', name: UserNickname }
}))
